import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const House: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 46 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M43.1155 31.0604C37.9155 39.0604 18.2822 37.3937 9.11549 35.5604C1.61549 33.3937 -8.28451 26.2604 12.1155 15.0604C32.5155 3.8604 39.9488 6.72706 41.1155 9.5604C43.9488 13.3937 48.3155 23.0604 43.1155 31.0604Z"
        fill="#0BA95E"
        fillOpacity="0.2"
      />
      <path
        d="M33.6947 7.74105C35.8278 7.74105 37.557 6.00816 37.557 3.87053C37.557 1.73289 35.8278 0 33.6947 0C31.5615 0 29.8323 1.73289 29.8323 3.87053C29.8323 6.00816 31.5615 7.74105 33.6947 7.74105Z"
        fill="#1B3029"
      />
      <path d="M28.6738 21.7009H31.1585V24.1908H28.6738V21.7009Z" fill="#1B3029" />
      <path
        d="M24.151 8.15895C24.6329 7.73052 25.2531 7.49462 25.8973 7.49462C26.5415 7.49462 27.1617 7.73057 27.6436 8.15895L28.3362 8.77454V6.57511C28.3362 2.95454 25.3968 0.0090332 21.7838 0.0090332C18.619 0.0090332 15.9712 2.26917 15.3629 5.26331C16.3578 6.77755 18.1013 9.73741 18.847 12.874L24.151 8.15895Z"
        fill="#1B3029"
      />
      <path
        d="M36.7383 28.2305H35.5267V19.8664L36.0977 20.374C36.2647 20.5224 36.4725 20.5955 36.6794 20.5954C36.9216 20.5954 37.1627 20.4955 37.336 20.2997C37.6575 19.9365 37.6243 19.3809 37.2619 19.0588L34.6904 16.7729V12.2172C34.6904 11.7317 34.2976 11.3382 33.8131 11.3382C33.3287 11.3382 32.9359 11.7317 32.9359 12.2172V15.2133L26.4794 9.47366C26.1472 9.17841 25.6473 9.17841 25.3152 9.47366L14.5328 19.0587C14.1704 19.3809 14.1372 19.9365 14.4586 20.2996C14.7801 20.6628 15.3346 20.696 15.697 20.3739L16.2679 19.8663V28.2303H13.4369V24.3954C13.8116 24.2806 14.1722 24.0922 14.5136 23.8338V22.2835C13.9892 22.1601 13.5098 21.877 13.1463 21.4664C12.1834 20.3787 12.2831 18.7086 13.3685 17.7436L17.3278 14.224C16.6614 9.96345 13.4184 5.52122 13.2653 5.31345C13.0999 5.08915 12.8381 4.95679 12.5597 4.95679C12.2814 4.95679 12.0196 5.08915 11.8542 5.31345C11.6834 5.54507 7.6719 11.0394 7.6719 15.6777C7.6719 17.9416 8.12243 20.0838 8.94052 21.7097C9.66216 23.1439 10.6151 24.069 11.6825 24.3954V28.2305H8.49269C8.00823 28.2305 7.61548 28.624 7.61548 29.1095C7.61548 29.5949 8.00823 29.9885 8.49269 29.9998H35.5268H36.7383C37.2228 29.9885 37.6155 29.5949 37.6155 29.1095C37.6155 28.624 37.2227 28.2305 36.7383 28.2305ZM26.9194 20.8216C26.9194 20.3362 27.3122 19.9426 27.7966 19.9426H32.0357C32.5202 19.9426 32.9129 20.3362 32.9129 20.8216V25.0696C32.9129 25.5551 32.5202 25.9486 32.0357 25.9486H27.7966C27.3122 25.9486 26.9194 25.5551 26.9194 25.0696V20.8216ZM22.116 28.2305V21.7007H20.3615V28.2305H18.6072V20.8216C18.6072 20.3361 18.9999 19.9426 19.4844 19.9426H22.9932C23.4776 19.9426 23.8704 20.3362 23.8704 20.8216V28.2305H22.116Z"
        fill="#1B3029"
      />
    </svg>
  )
})

House.displayName = 'House'
